export default [
  { value: "staircase cleaning", label: "staircase cleaning" },
  {
    value: "cleaning of staircase windows",
    label: "cleaning of staircase windows"
  },
  { value: "loft cleaning", label: "loft cleaning" },
  {
    value: "cleaning of cellar corridor",
    label: "cleaning of cellar corridor"
  },
  { value: "cleaning of letterbox", label: "cleaning of letterbox" },
  {
    value: "maintenance of green spaces",
    label: "maintenance of green spaces"
  },
  { value: "winter service", label: "winter service" },
  { value: "residents duty", label: "residents duty" },
  {
    value: "placement / clearing of bins",
    label: "placement / clearing of bins"
  }
];
